import script from "./exampleTableAiList.vue?vue&type=script&setup=true&lang=js"
export * from "./exampleTableAiList.vue?vue&type=script&setup=true&lang=js"

import "./exampleTableAiList.vue?vue&type=style&index=0&id=50291523&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50291523"]])

export default __exports__